import { defineStore } from 'pinia';
import { getGenerates, type ProjectGenerateStatus } from '~/api/projects';

export const useProjectWidgetStore = defineStore('projectWidget', () => {
  const project = ref<ProjectGenerateStatus | null>(null);

  function setProject(value: typeof project.value) {
    project.value = value;
  }

  const updateProject = async () => {
    const generates = await getGenerates().catch(() => []);
    console.log(generates);
    if (generates.length > 0) setProject(generates.at(-1)!);
  };

  return {
    project,
    setProject,
    updateProject,
  };
});
